<template>
  <div :class="['not-found-container', `v-theme--${isDarkMode ? 'dark' : 'light'}`]">
    <div class="not-found-content">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>The page you are looking for doesn't exist or has been moved.</p>
<!--      <router-link to="/" class="home-button">Go to Home</router-link>-->
    </div>
  </div>
</template>

<script>
import { useTheme } from 'vuetify'

export default {
  name: 'NotFound',
  setup () {
    const theme = useTheme()
    return {
      isDarkMode: theme.global.current.value.dark
    }
  }
}
</script>

<style scoped>
.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  background-color: rgb(var(--v-theme-background));
}

.not-found-content {
  max-width: 500px;
  padding: 2rem;
  background-color: rgb(var(--v-theme-surface));
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 6rem;
  margin: 0;
  color: rgb(var(--v-theme-error));
}

h2 {
  font-size: 2rem;
  margin-top: 0;
  margin-bottom: 1rem;
  color: rgb(var(--v-theme-on-surface));
}

p {
  margin-bottom: 2rem;
  color: rgb(var(--v-theme-on-surface-variant));
}

.home-button {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  background-color: rgb(var(--v-theme-primary));
  color: rgb(var(--v-theme-on-primary));
  text-decoration: none;
  border-radius: 4px;
  font-weight: bold;
  transition: background-color 0.3s;
}

.home-button:hover {
  background-color: rgb(var(--v-theme-primary-darken-1));
}
</style>
